import { render, staticRenderFns } from "./view.html?vue&type=template&id=2e5b8da0&scoped=true&"
import script from "./script.js?vue&type=script&lang=js&"
export * from "./script.js?vue&type=script&lang=js&"
import style0 from "./style.less?vue&type=style&index=0&id=2e5b8da0&lang=less&scoped=true&"
import style1 from "./style_mobile.less?vue&type=style&index=1&id=2e5b8da0&lang=less&scoped=true&"
import style2 from "./index.vue?vue&type=style&index=2&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e5b8da0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2e5b8da0')) {
      api.createRecord('2e5b8da0', component.options)
    } else {
      api.reload('2e5b8da0', component.options)
    }
    module.hot.accept("./view.html?vue&type=template&id=2e5b8da0&scoped=true&", function () {
      api.rerender('2e5b8da0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/rollCreate/index.vue"
export default component.exports